<template>
  <div class="content logout-page">
    <h1>Log Out</h1>

    <div class="text-center">
      <p>Are you sure you want to log out?</p>

      <b-button
        variant="primary"
        :disabled="buttonClicked"
        @click="logOut"
      >
        Yes, Log Out
      </b-button>

      <b-button
        type="button"
        variant="secondary"
        :disabled="buttonClicked"
        @click="$router.push({name: 'main'})"
      >
        Cancel
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogOut',
  data() {
    return {
      buttonClicked: false,
    };
  },
  metaInfo: {
    title: 'Log Out',
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$nextTick(() => {
      const main = document.querySelector('main');
      if (main) main.scrollTop = 0;
    });
  },
  methods: {
    logOut() {
      this.buttonClicked = true;
      this.logUserOut();
    },
  },
};
</script>
